import React from 'react';

const SummerChallenge = () => {
    const videoData = [
        { id: 'k-r092McADA', title: '1. den výzvy' },
        { id: 'yV_Atx9PaMs', title: '2. den výzvy' },
        { id: 'UVH944QAw2Q', title: '3. den výzvy' },
        { id: '8nY7dHLg1QU', title: '4. den výzvy' },
        { id: 'uFz3_qTdaD8', title: '5. den výzvy' },
        { id: 'Vc1EbCLxP6Q', title: '6. den výzvy' },
        { id: '9T2rDi0-2sU', title: '7. den výzvy' },
        { id: 'UfQ9NdtKc4Q', title: '8. den výzvy' },
        { id: '3lWp_pbKpAI', title: '9. den výzvy' },
        { id: 'Y3OXfMjaxfg', title: '10. den výzvy' },
        { id: 'Pi09MF9vvRU', title: '11. den výzvy' },
        { id: '5Q2k0CHMwjs', title: '12. den výzvy' },
        { id: 'F1o8sVJYlbE', title: '13. den výzvy' },
        { id: 'NGolvdLvzaE', title: '14. den výzvy' },
        { id: '34NgbPXlZXg', title: '15. den výzvy' },
        { id: 'g31ISxNVZIs', title: '16. den výzvy' },
        { id: 'AMKfb_7Zcos', title: '17. den výzvy' },
        { id: 'Q3RpyazZenI', title: '18. den výzvy' },
        { id: 'wLyxlBaQ8gI', title: '19. den výzvy' },
        { id: 'gzMHL4r870c', title: '20. den výzvy' },
        { id: 'gikatgApi4g', title: '21. den výzvy' },
        { id: 'fuG7NaO0oXQ', title: '22. den výzvy' },
        { id: 'j44oCiRMsqc', title: '23. den výzvy' },
        { id: 'hdyDHzVcayE', title: '24. den výzvy' },
        { id: 'Hj4f9PBXnB8', title: '25. den výzvy' },
        { id: 'Y-pXYrza5M4', title: '26. den výzvy' },
        { id: 'if3UU5jqvlE', title: '27. den výzvy' },
        { id: 'zpTpTtrGKxM', title: '28. den výzvy' },
        { id: 'H3Tjv85ZZ24', title: '29. den výzvy' },
        { id: 'Wfhl1SMEeYw', title: '30. den výzvy' },
    ];

    return (
        <section
            id="summer-challenge"
            className="relative py-20 bg-gray-900 text-white"
        >
            {/* Dekorativní prvky */}
            <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
                <div className="absolute w-96 h-96 bg-yellow-500/10 blur-3xl rounded-full -top-20 -right-20"></div>
                <div className="absolute w-96 h-96 bg-emerald-500/10 blur-3xl rounded-full bottom-0 left-0"></div>
            </div>

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <p className="eyebrow">Knihovna domácí praxe</p><h1 className="article-title">Letní výzva</h1>
                    <div className="w-24 h-1 bg-yellow-600 mx-auto mb-6"></div>
                    <p className="text-lg text-gray-300 max-w-2xl mx-auto">
                        Ponoř se do naší společné cesty. 30 dní, 30 videí, 30 kroků k větší harmonii.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {videoData.map((video, index) => (
                        <div key={video.id} className="group glass-effect bg-black/20 p-4 rounded-2xl border border-white/10 hover:border-yellow-500/50 transition duration-300">
                            
                            {/* Číslo nyní uvnitř boxu, dobře viditelné */}
                            <div className="flex items-center justify-start mb-4">
                                <span className="text-4xl font-black text-transparent stroke-yellow-500" 
                                      style={{ WebkitTextStroke: '1px #ca8a04' }}>
                                    {index + 1}.
                                </span>
                            </div>
                            
                            <div className="aspect-[9/16] w-full overflow-hidden rounded-xl bg-black/40">
                                <iframe
                                    loading="lazy"
                                    className="w-full h-full"
                                    src={`https://www.youtube-nocookie.com/embed/${video.id}`}
                                    title={video.title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                            <h3 className="mt-4 text-center font-medium text-gray-200">{video.title}</h3>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SummerChallenge;